import { useEffect, useState } from 'react'

/** Convierte Blob de RTK Query en object URL con revoke automático */
export default function usePdfBlobUrl(blob, isSuccess) {
  const [url, setUrl] = useState(null)

  useEffect(() => {
    let objectUrl = null
    if (isSuccess && blob instanceof Blob) {
      objectUrl = URL.createObjectURL(blob)
      setUrl(objectUrl)
    } else {
      setUrl(null)
    }
    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl)
      }
    }
  }, [blob, isSuccess])

  return url
}
